<template>
<div >

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<div class="mt-4" v-if="!loading" style="min-height:450px">

<template v-for="attribute in audit.audit.auditday.auditdayattributes">
<!-- if supplierattribute appended-->
    
  
  <template v-if="attribute.customattribute.type=='string'">
    <template v-for="translation in attribute.customattribute.translations">
      <ClickEditInputText v-show="translation.language_id == $store.state.auth.user.preflang_id" :title="attribute.customattribute.name" :value="attribute.customattribute.supplierattributes[0].attibutetextval" :valkey="attribute.customattribute.id" @dataChanged="attributeChanged"></ClickEditInputText>
    </template>
    
  </template>

  <template v-if="attribute.customattribute.type=='number'">
    <template v-for="translation in attribute.customattribute.translations">
    <ClickEditNumber v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="attribute.customattribute.name" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" @dataChanged="attributeChanged" />
    </template>
  </template>

  <template v-if="attribute.customattribute.type=='boolean'">
    <template v-for="translation in attribute.customattribute.translations">
    <ClickEditSwitch  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="attribute.customattribute.name" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" @dataChanged="attributeChanged" />
    </template>

    
  </template>

  <template v-if="attribute.customattribute.type=='select'">
    <template v-for="translation in attribute.customattribute.translations">
    <ClickEditSelect  v-show="translation.language_id == $store.state.auth.user.preflang_id"  :title="attribute.customattribute.name" :value="attribute.customattribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.customattribute.id" @dataChanged="attributeChanged" valkey="languages" :options="attribute.customattribute.options"   :color_selector="true" />
    </template>
    
  </template>


<!-- if supplierattribute appended-->
</template>


</div>
</div>
</template>

<script>
export default {

  name: 'AuditSubmittedCustomAttributes',

  data () {
    return {
      loading:true,
      audit:null,
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    dataChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"supplier/"+this.audit.flowsupplier.supplier.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response.data)
      this.getAuditData()
            
    },
    async getData()
    {
      this.loading = await true
      this.audit = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_id/"+this.$route.params.id)
      
      await this.getAuditData()
    },
    async getAuditData()
    {
      this.audit = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_data/"+this.audit.uuid)  
      console.log(this.audit)    
      this.loading = await false
    },
    attributeChanged(data)
    {
      console.log(data)
      console.log(this.$route.params)
      //return false
      let formdata = new FormData()
      formdata.append("data",data.value)
      formdata.append("customattribute_id",data.key)
      formdata.append("supplier_id",this.$route.params.id)
      this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+this.audit.flowsupplier.supplier.id,this.afterdataChanged)
    },
  }
}
</script>

<style lang="css" scoped>
</style>